module.exports = __webpack_public_path__ + "img/category-fundamentals.402e9b94.svg";